module.exports = __webpack_public_path__ + "media/images/icons/illustration/concept-3184cad414aee18d5b51966f82263fe9.svg";